module.exports = __webpack_public_path__ + "u.no1.fd0e6ff1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/u.no1.jpg
// module id = gwN5
// module chunks = 0